export const ChartSkeleton = () => (
  <div
    className="relative overflow-hidden rounded-lg bg-gray-100"
    style={{ height: "120px" }}
  >
    {/* grid lines */}
    <div className="absolute inset-0 flex flex-col justify-between p-3">
      <div className="h-[1px] bg-gray-200" />
      <div className="h-[1px] bg-gray-200" />
      <div className="h-[1px] bg-gray-200" />
      <div className="h-[1px] bg-gray-200" />
    </div>

    {/* shimmer */}
    <div className="absolute inset-0 -translate-x-full animate-shimmer bg-gradient-to-r from-transparent via-white/40 to-transparent" />
  </div>
);

export const MetricValueSkeleton = () => (
  <div className="mb-1 h-4 w-12 animate-pulse rounded bg-gray-200" />
);

export const BestPerformingSongSkeleton = () => (
  <div className="mx-auto h-[120px] w-full max-w-[400px] animate-pulse rounded-lg bg-gray-200" />
);

export const MetaCampaignRowSkeleton = () => (
  <div className="card-wrapper mb-3 animate-pulse font-lato">
    <div className="song-card mb-1 inline-flex w-full items-center overflow-hidden rounded-sm">
      <div className="h-[60px] w-[60px] min-w-[60px] bg-white/20" />
      <div className="info flex-1 space-y-2 bg-white/10 px-3 py-2">
        <div className="h-3.5 w-3/4 rounded bg-white/25" />
        <div className="h-3 w-1/2 rounded bg-white/20" />
      </div>
    </div>
    <div className="mt-1 flex justify-between gap-2 px-1">
      <div className="space-y-2">
        <div className="h-3 w-24 rounded bg-white/20" />
        <div className="h-2.5 w-20 rounded bg-white/15" />
      </div>
      <div className="h-5 w-5 rounded bg-white/20" />
    </div>
  </div>
);

export const MetaCampaignListSkeleton = ({ count = 3 }) => (
  <>
    {Array.from({ length: count }).map((_, index) => (
      <MetaCampaignRowSkeleton key={index} />
    ))}
  </>
);

export const PieChartSkeleton = () => (
  <div className="h-[160px] w-full flex items-center justify-center bg-gray-100 rounded-lg animate-pulse">
    <div className="h-[120px] w-[120px] rounded-full bg-gray-200" />
  </div>
);